import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Box, Flex, IconButton, useBreakpointValue } from '@chakra-ui/react';
import { LuEllipsisVertical } from 'react-icons/lu';
import { PopoverBody, PopoverContent, PopoverRoot, PopoverTrigger } from '../ui/popover';
import { Tooltip } from '../ui/tooltip';
type HeaderToolbarSlotProps = {
  toolbar: ReactNode;
};

/**
 * Renders the page toolbar inline at `lg`+ and behind a "More" overflow
 * popover below it (KBE-838). Below `lg` the header has no room for Show All /
 * search / the assumption-set selector, and previously they were hidden
 * outright (KBE-554) — which made the header look broken on tablets. The
 * toolbar node is mounted in exactly one place at a time so page-scoped
 * controls (e.g. the assumption-set change container's mount effect) don't run
 * twice. `fallback: 'lg'` keeps the inline branch on SSR and the first client
 * render, so desktop and e2e (1280px) are byte-identical to before.
 */
const HeaderToolbarSlot = t0 => {
  const $ = _c(8);
  const {
    toolbar
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: true,
      lg: false
    };
    t2 = {
      fallback: "lg"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const isCompact = useBreakpointValue(t1, t2);
  if (!toolbar) {
    return null;
  }
  if (!isCompact) {
    let t3;
    if ($[2] !== toolbar) {
      t3 = <Flex alignItems="center" flexWrap="nowrap" gap={2} minW={0} overflow="hidden">{toolbar}</Flex>;
      $[2] = toolbar;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      placement: "bottom-start"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PopoverTrigger asChild={true}><Box display="inline-block"><Tooltip content="Page tools" openDelay={200}><IconButton aria-label="Page tools" size="sm" variant="ghost"><LuEllipsisVertical size={18} /></IconButton></Tooltip></Box></PopoverTrigger>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== toolbar) {
    t5 = <PopoverRoot positioning={t3}>{t4}<PopoverContent width="auto"><PopoverBody><Flex alignItems="stretch" direction="column" gap={3}>{toolbar}</Flex></PopoverBody></PopoverContent></PopoverRoot>;
    $[6] = toolbar;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default HeaderToolbarSlot;